import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Navigation
      "dashboard": "Dashboard",
      "properties": "Properties",
      "users": "Users",
      "bookings": "Bookings",
      "currencies": "Currencies",
      "database_admin": "Database Admin",
      "logout": "Logout",
      "login": "Login",
      "register": "Register",
      "profile": "Profile",
      
      // Common
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "add": "Add",
      "view": "View",
      "back": "Back",
      "loading": "Loading...",
      "error": "Error",
      "success": "Success",
      "access_denied": "Access Denied",
      "yes": "Yes",
      "no": "No",
      "confirm": "Confirm",
      "close": "Close",
      "search": "Search",
      "filter": "Filter",
      "actions": "Actions",
      "status": "Status",
      "name": "Name",
      "description": "Description",
      "type": "Type",
      "address": "Address",
      "city": "City",
      "country": "Country",
      "phone": "Phone",
      "email": "Email",
      "date": "Date",
      "time": "Time",
      "amount": "Amount",
      "total": "Total",
      "language": "Language",
      
      // Property Management
      "property_management": "Property Management",
      "property_details": "Property Details",
      "add_property": "Add Property",
      "edit_property": "Edit Property",
      "property_name": "Property Name",
      "property_type": "Property Type",
      "property_address": "Property Address",
      "main_image": "Main Image",
      "images": "Images",
      "videos": "Videos",
      "facilities": "Facilities",
      "property_facilities": "Property Facilities",
      "special_specs": "Special Specifications",
      "special_features": "Special Features",
      "owner": "Owner",
      "created_by": "Created By",
      "units": "Units",
      "media_gallery": "Media Gallery",
      "upload_media": "Upload Media",
      "upload_main_image": "Upload Main Image",
      "upload_images_videos": "Upload Images/Videos",
      "no_media_files": "No media files yet",
      "delete_media_confirm": "Are you sure you want to delete this media file?",
      "show_on_calendar": "Show on Calendar",
      "hide_from_calendar": "Hide from Calendar",
      
      // Units
      "unit_details": "Unit Details",
      "add_unit": "Add Unit",
      "edit_unit": "Edit Unit",
      "unit_number": "Unit Number",
      "unit_name": "Unit Name",
      "unit_type": "Unit Type",
      "rent_amount": "Rent Amount",
      "bedrooms": "Bedrooms",
      "bathrooms": "Bathrooms",
      "square_feet": "Square Feet",
      "rental_types": "Rental Types",
      "unit_status": "Unit Status",
      "vacant": "Vacant",
      "occupied": "Occupied",
      "maintenance": "Maintenance",
      "apartment": "Apartment",
      "room": "Room",
      "studio": "Studio",
      "living_rooms": "Living Rooms",
      "mens_guest_rooms": "Men's Guest Rooms",
      "womens_guest_rooms": "Women's Guest Rooms",
      "single_beds": "Single Beds",
      "double_beds": "Double Beds",
      "max_persons": "Max Persons",
      "checkin_time": "Check-in Time",
      "checkout_time": "Check-out Time",
      "tax_rate": "Tax Rate",
      "room_configuration": "Room Configuration",
      "bed_configuration": "Bed Configuration",
      "checkin_checkout_times": "Check-in/Check-out Times",
      "financial_settings": "Financial Settings",
      "suite": "Suite",
      
      // File Upload
      "supported_formats": "Supported formats: Images (JPEG, PNG, GIF, SVG) up to 10MB, Videos (MP4, MOV, AVI, WMV) up to 50MB",
      "file_too_large": "File is too large",
      "invalid_file_format": "Invalid file format",
      "upload_successful": "Upload successful",
      "upload_failed": "Upload failed",
      
      // Forms
      "required_field": "This field is required",
      "all_fields_required": "All fields are required",
      "invalid_email": "Please enter a valid email address",
      "password_min_length": "Password must be at least 6 characters",
      "password_min_length_6": "Password must be at least 6 characters",
      "passwords_dont_match": "Passwords don't match",
      
      // Booking
      "booking_details": "Booking Details",
      "add_booking": "Add Booking",
      "allow_past_bookings": "Allow Past Bookings",
      "check_in": "Check In",
      "check_out": "Check Out",
      "guest_name": "Guest Name",
      "guest_phone": "Guest Phone",
      "guest_email": "Guest Email",
      "booking_status": "Booking Status",
      "confirmed": "Confirmed",
      "pending": "Pending",
      "cancelled": "Cancelled",
      "pending_bookings": "Pending Bookings",
      "total_revenue": "Total Revenue",
      "refresh": "Refresh",
      "refresh_booking_data": "Refresh booking data",
      "payment_status": "Payment Status",
      "not_paid": "Not Paid",
      "partially_paid": "Partially Paid",
      "fully_paid": "Fully Paid",
      
      // Calendar
      "calendar": {
        "checkedIn": "Checked In",
        "checkedOut": "Checked Out",
        "awaitingCheckIn": "Awaiting Check-in"
      },
      "checkin_checkout": "Check-in/out",
      "select_checkin_status": "Select Check-in Status",
      "waiting_for_checkin": "Waiting for Check-in",
      "checked_in": "Checked In",
      "checked_out": "Checked Out",
      "update_status": "Update Status",
      "updating_status": "Updating...",
      "unit_cleaning_note": "Note: Unit cleaning status will be automatically set to \"Not Cleaned\"",
      
      // Cleaning Management
      "cleaning": "Cleaning",
      "select_cleaning_status": "Select Cleaning Status",
      "cleaned": "Cleaned",
      "not_cleaned": "Not Cleaned",
      
      // Currency Management
      "currency": "Currency",
      "select_currency": "Select Currency",
      "failed_load_currencies": "Failed to load currencies",
      "add_currency": "Add Currency",
      "edit_currency": "Edit Currency",
      "currency_code": "Currency Code",
      "currency_name": "Currency Name",
      "symbol": "Symbol",
      "exchange_rate": "Exchange Rate",
      "default_currency": "Default Currency",
      "base_exchange_rate": "Base Exchange Rate",
      "currency_created": "Currency created successfully",
      "currency_updated": "Currency updated successfully",
      "currency_deleted": "Currency deleted successfully",
      "currency_creation_failed": "Failed to create currency",
      "currency_update_failed": "Failed to update currency",
      "currency_deletion_failed": "Failed to delete currency",
      "default_currency_updated": "Default currency updated successfully",
      "default_currency_update_failed": "Failed to update default currency",
      "confirm_delete_currency": "Are you sure you want to delete this currency?",
      "currency_code_required": "Currency code is required",
      "currency_code_format": "Currency code must be 3 uppercase letters",
      "currency_code_help": "e.g., USD, EUR, SAR",
      "currency_name_required": "Currency name is required",
      "currency_symbol_required": "Currency symbol is required",
      "exchange_rate_required": "Exchange rate is required",
      "exchange_rate_min": "Exchange rate must be greater than 0",
      "exchange_rate_help": "Rate relative to the default currency",
      "default": "Default",
      
      // User Management
      "user_management": "User Management",
      "add_user": "Add User",
      "edit_user": "Edit User",
      "user_details": "User Details",
      "full_name": "Full Name",
      "username": "Username",
      "password": "Password",
      "confirm_password": "Confirm Password",
      "user_role": "User Role",
      "admin": "Admin",
      "user": "User",
      "permissions": "Permissions",
      
      // Database Administration
      "database_administration": "Database Administration",
      "backup_database": "Backup Database",
      "restore_database": "Restore Database",
      "database_settings": "Database Settings",
      "create_backup": "Create Backup",
      "restore_backup": "Restore Backup",
      "backup_created": "Backup created successfully",
      "backup_failed": "Failed to create backup",
      "restore_completed": "Database restored successfully",
      "restore_failed": "Failed to restore database",
      "change_db_credentials": "Change Database Credentials",
      "database_user": "Database User",
      "database_password": "Database Password",
      "db_current_password": "Current Database Password",
      "db_new_password": "New Database Password",
      "db_confirm_new_password": "Confirm New Database Password",
      "credentials_updated": "Database credentials updated successfully",
      "credentials_update_failed": "Failed to update database credentials",
      "backup_file": "Backup File",
      "select_backup_file": "Select Backup File",
      "download_backup": "Download Backup",
      "backup_size": "Backup Size",
      "backup_date": "Backup Date",
      "confirm_restore": "Are you sure you want to restore the database? This will overwrite all current data.",
      "confirm_backup": "Are you sure you want to create a backup?",
      
      // Owner Management
      "owner_management": "Owner Management",
      "add_owner": "Add Owner",
      "edit_owner": "Edit Owner",
      "owner_details": "Owner Details",
      "owner_name": "Owner Name",
      "nationality": "Nationality",
      "mobile_number": "Mobile Number",
      "assign_owner": "Assign Owner",
      
      // Messages
      "welcome_message": "Welcome to Property Management System",
      "login_success": "Login successful",
      "logout_success": "Logout successful",
      "property_created": "Property created successfully",
      "property_updated": "Property updated successfully",
      "property_deleted": "Property deleted successfully",
      "unit_created": "Unit created successfully",
      "unit_updated": "Unit updated successfully",
      "unit_deleted": "Unit deleted successfully",
      "user_created": "User created successfully",
      "user_updated": "User updated successfully",
      "user_deleted": "User deleted successfully",
      "booking_created": "Booking created successfully",
      "booking_updated": "Booking updated successfully",
      "booking_deleted": "Booking deleted successfully",
      
      // Booking conflicts
      "cannot_create_booking_past_date": "Cannot create booking for {{date}} - date is in the past. Enable \"Allow Past Bookings\" to create bookings for past dates.",
      "booking_conflict_check_failed": "Warning: Could not check for booking conflicts. Please verify availability manually.",
      "conflicting_booking_details": "Conflicting booking: #{{id}} - {{tenant}} ({{startDate}} to {{endDate}}) on {{unitName}}",
      "conflict_same_unit": "Unit '{{unitName}}' is already booked for the selected dates.",
      "conflict_parent_unit": "Cannot book '{{unitName}}' because its parent unit '{{conflictingUnitName}}' is already booked for overlapping dates.",
      "conflict_child_unit": "Cannot book '{{unitName}}' because its child unit '{{conflictingUnitName}}' is already booked for overlapping dates.",
      "conflict_default": "Booking conflict detected for the selected dates.",
      
      // Dashboard specific
      "welcome_back": "Welcome back",
      "whats_happening_today": "Here's what's happening with your properties today.",
      "total_properties": "Total Properties",
      "total_units": "Total Units",
      "total_bookings": "Total Bookings",
      "active_bookings": "Active Bookings",
      "properties_managed": "Properties managed",
      "available_units": "Available units",
      "all_time_bookings": "All time bookings",
      "currently_active": "Currently active",
      "all_properties": "All Properties",
      "your_properties": "Your Properties",
      "no_properties_yet": "No Properties Yet",
      "start_creating_first_property": "Start by creating your first property",
      "ask_admin_assign_properties": "Ask your admin to assign properties to you",
      "add_your_first_property": "Add Your First Property",
      "create_first_property": "Create your first property to get started",
      
      // Properties page specific
      "manage_property_portfolio": "Manage your property portfolio",
      "view_details": "View Details",
      "facilities_label": "Facilities:",
      "more_facilities": "more",
      "press_enter_to_add": "Press Enter to add items",
      "property_type_apartment": "Building",
      "property_type_house": "Single Unit",
      "property_type_condo": "Condo", 
      "property_type_townhouse": "Townhouse",
      "property_type_commercial": "Commercial",
      "property_type_building": "Building",
      "property_type_villa": "Villa",
      "property_type_other": "Other",
      "select_property_to_view_reports": "Please select a property to view financial reports",
      "select_property_to_view_income": "Please select a property to view income statement",
      "unit_type_apartment": "Apartment",
      "unit_type_room": "Room",
      "unit_type_studio": "Studio",
      "unit_type_suite": "Suite",
      "mobile_phone_1": "Mobile Number",
      "mobile_phone_2": "Whatsapp Number",
      "special_specifications": "Special Specifications",
      "select_country": "Select a country",
      "saving": "Saving...",
      "create": "Create",
      "update": "Update",
      "failed_fetch_properties": "Failed to fetch properties",
      "failed_save_property": "Failed to save property",
      
      // Registration/Login specific
      "create_account": "Create Account",
      "join_property_management": "Join our Property Management system",
      "sign_in_to_account": "Sign in to your Property Management account",
      "demo_accounts": "Demo Accounts:",
      "admin_demo": "Admin: admin@property.com / password123",
      "user_demo": "User: john@property.com / password123",
      "email_address": "Email Address",
      "creating_account": "Creating Account...",
      "already_have_account": "Already have an account?",
      "sign_in_here": "Sign in here",
      "registration_failed": "Registration failed",
      "name_required": "Name is required",
      "name_min_length": "Name must be at least 2 characters",
      "email_required": "Email is required",
      "invalid_email_format": "Invalid email format",
      "password_required": "Password is required",
      "password_must_match": "Passwords must match",
      "confirm_password_required": "Confirm password is required",
      
      // Profile page
      "my_profile": "My Profile",
      "profile_information": "Profile Information",
      "phone_number": "Phone Number",
      "not_provided": "Not provided",
      "change_password": "Change Password",
      "current_password": "Current Password",
      "new_password": "New Password",
      "confirm_new_password": "Confirm New Password",
      "current_password_required": "Current password is required",
      "new_password_required": "New password is required",
      "passwords_do_not_match": "Passwords do not match",
      "update_password": "Update Password",
      "updating": "Updating...",
      "password_change_description": "Change your account password to keep your account secure.",
      "profile_updated_successfully": "Profile updated successfully",
      "profile_update_failed": "Failed to update profile",
      "password_updated_successfully": "Password updated successfully",
      "password_update_failed": "Failed to update password",
      "user_not_found": "User not found",
      "account_information": "Account Information",
      "user_id": "User ID",
      "account_status": "Account Status",
      "active": "Active",
      "inactive": "Inactive",
      "member_since": "Member Since",
      "email_verified": "Email Verified",
      "verified": "Verified",
      "not_verified": "Not Verified",
      "preferences": "Preferences",
      "assigned_properties": "Assigned Properties",
      "you_have_access_to": "You have access to",
      "administrator": "Administrator",
      "property_manager": "Property Manager",
      "staff": "Staff",
      
      // Users page
      "user_management_system": "User Management System",
      "manage_users_permissions": "Manage users and their permissions",
      "no_users_found": "No users found",
      "add_new_user": "Add New User",
      "no_assignments": "No assignments",
      "assign_property": "Assign Property",
      "assign_properties_to_cleaner": "Assign Properties to Cleaner",
      "view_user_details": "View User Details",
      "delete_user": "Delete User",
      "create_user": "Create User",
      "update_user": "Update User",
      
      // Purchase Invoice
      "purchase_invoice": "Purchase Invoice",
      "invoice_information": "Invoice Information",
      "invoice_number": "Invoice Number",
      "invoice_date": "Invoice Date",
      "vendor_name": "Vendor Name",
      "vendor_address": "Vendor Address",
      "due_date": "Due Date",
      "line_items": "Line Items",
      "add_item": "Add Item",
      "total_amount": "Total Amount",
      "additional_notes_optional": "Additional notes (optional)",
      "create_invoice": "Create Invoice",
      "please_select_expense_category_first": "Please select expense category for the first item before adding more items",
      "active_users": "Active Users",
      "inactive_users": "Inactive Users",
      "all_users": "All Users",
      "role": "Role",
      "created_at": "Created At",
      "last_login": "Last Login",
      "never": "Never",
      
      // Bookings page  
      "booking_management": "Booking Management",
      "manage_all_bookings": "Manage all bookings and reservations",
      "no_bookings_found": "No bookings found",
      "add_new_booking": "Add New Booking",
      "guest_information": "Guest Information",
      "booking_information": "Booking Information",
      "check_in_date": "Check-in Date",
      "check_out_date": "Check-out Date",
      "select_property": "Select Property",
      "select_unit": "Select Unit",
      "property_required": "Property is required",
      "unit_required": "Unit is required",
      "guest_name_required": "Guest name is required",
      "checkin_required": "Check-in date is required",
      "checkout_required": "Check-out date is required",
      "creating_booking": "Creating booking...",
      "updating_booking": "Updating booking...",
      "booking_saved": "Booking saved successfully",
      "booking_error": "Error saving booking",
      
      // Map location picker
      "select_location_on_map": "Select Location on Map",
      "search_address": "Search Address",
      "use_current_location": "Use Current Location",
      "getting_location": "Getting location...",
      "click_map_to_select_location": "Click on the map to select a location",
      "selected_coordinates": "Selected coordinates",
      "confirm_location": "Confirm Location",
      "address_not_found": "Address not found",
      "geocoding_error": "Error searching for address",
      "location_access_denied": "Location access denied",
      "location_access_denied_detailed": "Location access denied. Please allow location access in your browser settings and try again.",
      "geolocation_not_supported": "Geolocation is not supported by this browser",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "select_on_map": "Select on Map",
      "location": "Location",
      "location_not_available": "Location not available",
      "no_location_set": "No location has been set for this property",
      "set_location_instructions": "To set a location for this property, go to the Properties page and edit this property using the map picker.",
      "go_to_properties": "Go to Properties",
      "edit_location": "Edit Location",
      "set_location": "Set Location",
      "click_set_location_to_add": "Click 'Set Location' button to add a location for this property",
      "please_select_location": "Please select a location on the map",
      "location_unavailable": "Location unavailable",
      "location_unavailable_detailed": "Your location is currently unavailable. Please check your device's location settings.",
      "location_timeout": "Location request timed out",
      "location_timeout_detailed": "Location request timed out. Please try again or select your location on the map.",
      "location_error": "Error getting location",
      "location_error_detailed": "Failed to get your location. Please try again or select your location on the map.",
      "location_requires_https": "Location access requires a secure connection (HTTPS). Please use HTTPS or select your location on the map.",
      "location_permission_denied_status": "Location access is currently blocked. Please enable location access in your browser settings.",
      "location_access_help": "How to enable location access",
      "location_access_help_intro": "To use your current location, your browser needs permission to access your location. Here's how to enable it:",
      "browser_instructions": "Browser Instructions",
      "chrome_location_instructions": "Click the location icon in the address bar, then select 'Allow'",
      "firefox_location_instructions": "Click the shield icon in the address bar, then enable location access",
      "safari_location_instructions": "Go to Safari > Settings > Websites > Location, then allow access",
      "location_access_alternative": "Alternative",
      "click_map_to_select_manually": "Click anywhere on the map to select your location manually",
      "help": "Help",
      "view_on_google_maps": "View on Google Maps",
      "view_on_openstreetmap": "View on OpenStreetMap",
      "enter_location_url": "Enter Location URL",
      "supported_urls_description": "Supports Google Maps, OpenStreetMap, Apple Maps, Bing Maps, and coordinate URLs",
      "paste_location_url_placeholder": "Paste a location URL (e.g., from Google Maps, OpenStreetMap, etc.)",
      "extract_location": "Extract Location",
      "please_enter_location_url": "Please enter a location URL",
      "could_not_extract_coordinates": "Could not extract coordinates from the URL. Please check the URL format.",
      "shortened_url_not_supported": "Shortened URLs are not directly supported. Please open the link in your browser and copy the full URL from the address bar.",
      "or_enter_location_url": "Or Enter Location URL",
      "paste_url_from_google_maps_etc": "Paste a URL from Google Maps, OpenStreetMap, or any mapping service",
      "extract": "Extract",
      "coordinates": "Coordinates",
      
      // Accounting
      "accounting": "Accounting",
      "accounting_description": "Manage your property finances, track revenue and expenses",
      "chart_of_accounts": "Chart of Accounts",
      "accounting_dashboard": "Accounting Dashboard",
      "net_income": "Net Income",
      "cash_balance": "Cash Balance",
      "accounts_receivable": "Accounts Receivable",
      "accounts_payable": "Accounts Payable",
      "journal_entries": "Journal Entries",
      "general_ledger": "General Ledger",
      "income_statement": "Income Statement",
      "balance_sheet": "Balance Sheet",
      "create_transaction": "Create Transaction",
      "account_code": "Account Code",
      "account_name": "Account Name",
      "account_type": "Account Type",
      "normal_balance": "Normal Balance",
      "debit": "Debit",
      "credit": "Credit",
      "transaction_date": "Transaction Date",
      "transaction_type": "Transaction Type",
      "booking_payment": "Booking Payment",
      "property_expense": "Property Expense",
      "adjustment": "Adjustment",
      "posted": "Posted",
      "draft": "Draft",
      "asset": "Asset",
      "liability": "Liability",
      "equity": "Equity",
      "income": "Income",
      "cogs": "Cost of Goods Sold",
      "operating_expense": "Operating Expense",
      "other_income": "Other Income",
      "other_expense": "Other Expense",
      "current_assets": "Current Assets",
      "fixed_assets": "Fixed Assets",
      "current_liabilities": "Current Liabilities",
      "long_term_liabilities": "Long Term Liabilities",
      "debit_amount": "Debit Amount",
      "credit_amount": "Credit Amount",
      "transaction_total": "Transaction Total",
      "post_transaction": "Post Transaction",
      "view_transaction": "View Transaction",
      "transaction_details": "Transaction Details",
      "account_balance": "Account Balance",
      "running_balance": "Running Balance",
      
      // Calendar Display Options
      "day_display": "Day Display",
      "none": "None",
      "day_numbers": "Day Numbers",
      "rates": "Rates",
      "calendar_mode": "Calendar Mode",
      "booking": "Booking",
      "change_rate": "Change Rate",
      
      // Payment Vouchers
      "payment_vouchers": "Payment Vouchers",
      "payment_voucher": "Payment Voucher",
      "create_payment_voucher": "Create Payment Voucher",
      "voucher_number": "Voucher Number",
      "broker_information": "Broker Information",
      "payment_date": "Payment Date",
      "payment_method": "Payment Method",
      "remaining_amount": "Remaining Amount",
      "pay_full_amount": "Pay Full Amount",
      "pay_half_amount": "Pay Half Amount",
      "create_voucher": "Create Voucher",
      "creating": "Creating...",
      "confirm_approve_voucher": "Are you sure you want to approve this voucher?",
      "confirm_pay_voucher": "Are you sure you want to pay this voucher?",
      "confirm_cancel_voucher": "Are you sure you want to cancel this voucher?",
      "confirm_delete_voucher": "Are you sure you want to delete this voucher?",
      "error_loading_vouchers": "Error loading vouchers",
      "no_vouchers_found": "No vouchers found",
      "select_broker_first": "Select a broker first",
      "no_bookings_with_commission": "No bookings with commission found",
      "optional": "Optional",
      "no_booking_selected": "No booking selected"
    }
  },
  ar: {
    translation: {
      // Navigation
      "dashboard": "لوحة التحكم",
      "properties": "العقارات",
      "users": "المستخدمون",
      "bookings": "الحجوزات",
      "currencies": "العملات",
      "database_admin": "إدارة قاعدة البيانات",
      "logout": "تسجيل الخروج",
      "login": "تسجيل الدخول",
      "register": "إنشاء حساب",
      "profile": "الملف الشخصي",
      
      // Common
      "save": "حفظ",
      "cancel": "إلغاء",
      "delete": "حذف",
      "edit": "تعديل",
      "add": "إضافة",
      "view": "عرض",
      "back": "العودة",
      "loading": "جاري التحميل...",
      "error": "خطأ",
      "success": "نجح",
      "access_denied": "تم رفض الوصول",
      "yes": "نعم",
      "no": "لا",
      "confirm": "تأكيد",
      "close": "إغلاق",
      "search": "بحث",
      "filter": "تصفية",
      "actions": "الإجراءات",
      "status": "الحالة",
      "name": "الاسم",
      "description": "الوصف",
      "type": "النوع",
      "address": "العنوان",
      "city": "المدينة",
      "country": "الدولة",
      "phone": "الهاتف",
      "email": "البريد الإلكتروني",
      "date": "التاريخ",
      "time": "الوقت",
      "amount": "المبلغ",
      "total": "المجموع",
      "language": "اللغة",
      
      // Property Management
      "property_management": "إدارة العقارات",
      "property_details": "تفاصيل العقار",
      "add_property": "إضافة عقار",
      "edit_property": "تعديل العقار",
      "property_name": "اسم العقار",
      "property_type": "نوع العقار",
      "property_address": "عنوان العقار",
      "main_image": "الصورة الرئيسية",
      "images": "الصور",
      "videos": "الفيديوهات",
      "facilities": "المرافق",
      "property_facilities": "مرافق العقار",
      "special_specs": "المواصفات الخاصة",
      "special_features": "الميزات الخاصة",
      "owner": "المالك",
      "created_by": "أنشأ بواسطة",
      "units": "الوحدات",
      "media_gallery": "معرض الوسائط",
      "upload_media": "رفع الوسائط",
      "upload_main_image": "رفع الصورة الرئيسية",
      "upload_images_videos": "رفع الصور/الفيديوهات",
      "no_media_files": "لا توجد ملفات وسائط حتى الآن",
      "delete_media_confirm": "هل أنت متأكد من حذف هذا الملف؟",
      "show_on_calendar": "إظهار في التقويم",
      "hide_from_calendar": "إخفاء من التقويم",
      
      // Units
      "unit_details": "تفاصيل الوحدة",
      "add_unit": "إضافة وحدة",
      "edit_unit": "تعديل الوحدة",
      "unit_number": "رقم الوحدة",
      "unit_name": "اسم الوحدة",
      "unit_type": "نوع الوحدة",
      "rent_amount": "مبلغ الإيجار",
      "bedrooms": "غرف النوم",
      "bathrooms": "الحمامات",
      "square_feet": "المساحة بالقدم المربع",
      "rental_types": "أنواع الإيجار",
      "unit_status": "حالة الوحدة",
      "vacant": "شاغرة",
      "occupied": "مؤجرة",
      "maintenance": "صيانة",
      "apartment": "شقة",
      "room": "غرفة",
      "studio": "استوديو",
      "suite": "جناح",
      "living_rooms": "غرف المعيشة",
      "mens_guest_rooms": "غرف الضيوف للرجال",
      "womens_guest_rooms": "غرف الضيوف للنساء",
      "single_beds": "أسرّة فردية",
      "double_beds": "أسرّة مزدوجة",
      "max_persons": "الحد الأقصى للأشخاص",
      "checkin_time": "وقت تسجيل الوصول",
      "checkout_time": "وقت تسجيل المغادرة",
      "tax_rate": "معدل الضريبة",
      "room_configuration": "تكوين الغرف",
      "bed_configuration": "تكوين الأسرّة",
      "checkin_checkout_times": "أوقات تسجيل الوصول/المغادرة",
      "financial_settings": "الإعدادات المالية",
      
      // File Upload
      "supported_formats": "الصيغ المدعومة: الصور (JPEG, PNG, GIF, SVG) حتى 10 ميجابايت، الفيديوهات (MP4, MOV, AVI, WMV) حتى 50 ميجابايت",
      "file_too_large": "الملف كبير جداً",
      "invalid_file_format": "صيغة الملف غير صالحة",
      "upload_successful": "تم الرفع بنجاح",
      "upload_failed": "فشل في الرفع",
      
      // Forms
      "required_field": "هذا الحقل مطلوب",
      "all_fields_required": "جميع الحقول مطلوبة",
      "invalid_email": "يرجى إدخال عنوان بريد إلكتروني صالح",
      "password_min_length": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
      "password_min_length_6": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
      "passwords_dont_match": "كلمات المرور غير متطابقة",
      
      // Booking
      "booking_details": "تفاصيل الحجز",
      "add_booking": "إضافة حجز",
      "allow_past_bookings": "السماح بالحجوزات السابقة",
      "check_in": "تاريخ الوصول",
      "check_out": "تاريخ المغادرة",
      "guest_name": "اسم الضيف",
      "guest_phone": "هاتف الضيف",
      "guest_email": "بريد الضيف الإلكتروني",
      "booking_status": "حالة الحجز",
      "confirmed": "مؤكد",
      "pending": "في الانتظار",
      "cancelled": "ملغي",
      "pending_bookings": "الحجوزات المعلقة",
      "total_revenue": "إجمالي الإيرادات",
      "refresh": "تحديث",
      "refresh_booking_data": "تحديث بيانات الحجوزات",
      "payment_status": "حالة الدفع",
      "not_paid": "غير مدفوع",
      "partially_paid": "مدفوع جزئياً",
      "fully_paid": "مدفوع بالكامل",
      
      // Calendar
      "calendar": {
        "checkedIn": "تم تسجيل الوصول",
        "checkedOut": "تم تسجيل المغادرة",
        "awaitingCheckIn": "في انتظار تسجيل الوصول"
      },
      "checkin_checkout": "تسجيل الوصول/المغادرة",
      "select_checkin_status": "اختر حالة تسجيل الوصول",
      "waiting_for_checkin": "في انتظار تسجيل الوصول",
      "checked_in": "تم تسجيل الوصول",
      "checked_out": "تم تسجيل المغادرة",
      "update_status": "تحديث الحالة",
      "updating_status": "جاري التحديث...",
      "unit_cleaning_note": "ملاحظة: سيتم تعيين حالة تنظيف الوحدة تلقائياً إلى \"غير منظفة\"",
      
      // Cleaning Management
      "cleaning": "تنظيف",
      "select_cleaning_status": "اختر حالة التنظيف",
      "cleaned": "منظف",
      "not_cleaned": "غير منظف",
      
      // Currency Management
      "currency": "العملة",
      "select_currency": "اختر العملة",
      "failed_load_currencies": "فشل في تحميل العملات",
      "add_currency": "إضافة عملة",
      "edit_currency": "تعديل العملة",
      "currency_code": "رمز العملة",
      "currency_name": "اسم العملة",
      "symbol": "الرمز",
      "exchange_rate": "سعر الصرف",
      "default_currency": "العملة الافتراضية",
      "base_exchange_rate": "سعر الصرف الأساسي",
      "currency_created": "تم إنشاء العملة بنجاح",
      "currency_updated": "تم تحديث العملة بنجاح",
      "currency_deleted": "تم حذف العملة بنجاح",
      "currency_creation_failed": "فشل في إنشاء العملة",
      "currency_update_failed": "فشل في تحديث العملة",
      "currency_deletion_failed": "فشل في حذف العملة",
      "default_currency_updated": "تم تحديث العملة الافتراضية بنجاح",
      "default_currency_update_failed": "فشل في تحديث العملة الافتراضية",
      "confirm_delete_currency": "هل أنت متأكد من حذف هذه العملة؟",
      "currency_code_required": "رمز العملة مطلوب",
      "currency_code_format": "يجب أن يكون رمز العملة 3 أحرف كبيرة",
      "currency_code_help": "مثال: USD, EUR, SAR",
      "currency_name_required": "اسم العملة مطلوب",
      "currency_symbol_required": "رمز العملة مطلوب",
      "exchange_rate_required": "سعر الصرف مطلوب",
      "exchange_rate_min": "يجب أن يكون سعر الصرف أكبر من 0",
      "exchange_rate_help": "السعر نسبة إلى العملة الافتراضية",
      "default": "افتراضي",
      
      // User Management
      "user_management": "إدارة المستخدمين",
      "add_user": "إضافة مستخدم",
      "edit_user": "تعديل المستخدم",
      "user_details": "تفاصيل المستخدم",
      "full_name": "الاسم الكامل",
      "username": "اسم المستخدم",
      "password": "كلمة المرور",
      "confirm_password": "تأكيد كلمة المرور",
      "user_role": "دور المستخدم",
      "admin": "مدير",
      "user": "مستخدم",
      "permissions": "الصلاحيات",
      "administrators": "المديرون",
      "property_managers": "مديرو العقارات",
      "cleaners": "المنظفون",
      "property_assignments": "تعيينات العقارات",
      
      // Database Administration
      "database_administration": "إدارة قاعدة البيانات",
      "backup_database": "نسخ احتياطي لقاعدة البيانات",
      "restore_database": "استعادة قاعدة البيانات",
      "database_settings": "إعدادات قاعدة البيانات",
      "create_backup": "إنشاء نسخة احتياطية",
      "restore_backup": "استعادة النسخة الاحتياطية",
      "backup_created": "تم إنشاء النسخة الاحتياطية بنجاح",
      "backup_failed": "فشل في إنشاء النسخة الاحتياطية",
      "restore_completed": "تمت استعادة قاعدة البيانات بنجاح",
      "restore_failed": "فشل في استعادة قاعدة البيانات",
      "change_db_credentials": "تغيير بيانات اعتماد قاعدة البيانات",
      "database_user": "مستخدم قاعدة البيانات",
      "database_password": "كلمة مرور قاعدة البيانات",
      "db_current_password": "كلمة المرور الحالية لقاعدة البيانات",
      "db_new_password": "كلمة المرور الجديدة لقاعدة البيانات",
      "db_confirm_new_password": "تأكيد كلمة المرور الجديدة لقاعدة البيانات",
      "credentials_updated": "تم تحديث بيانات اعتماد قاعدة البيانات بنجاح",
      "credentials_update_failed": "فشل في تحديث بيانات اعتماد قاعدة البيانات",
      "backup_file": "ملف النسخة الاحتياطية",
      "select_backup_file": "اختر ملف النسخة الاحتياطية",
      "download_backup": "تحميل النسخة الاحتياطية",
      "backup_size": "حجم النسخة الاحتياطية",
      "backup_date": "تاريخ النسخة الاحتياطية",
      "confirm_restore": "هل أنت متأكد من أنك تريد استعادة قاعدة البيانات؟ سيؤدي هذا إلى استبدال جميع البيانات الحالية.",
      "confirm_backup": "هل أنت متأكد من أنك تريد إنشاء نسخة احتياطية؟",
      
      // Owner Management
      "owner_management": "إدارة المالكين",
      "add_owner": "إضافة مالك",
      "edit_owner": "تعديل المالك",
      "owner_details": "تفاصيل المالك",
      "owner_name": "اسم المالك",
      "nationality": "الجنسية",
      "mobile_number": "رقم الجوال",
      "assign_owner": "تعيين مالك",
      
      // Messages
      "welcome_message": "مرحباً بك في نظام إدارة العقارات",
      "login_success": "تم تسجيل الدخول بنجاح",
      "logout_success": "تم تسجيل الخروج بنجاح",
      "property_created": "تم إنشاء العقار بنجاح",
      "property_updated": "تم تحديث العقار بنجاح",
      "property_deleted": "تم حذف العقار بنجاح",
      "unit_created": "تم إنشاء الوحدة بنجاح",
      "unit_updated": "تم تحديث الوحدة بنجاح",
      "unit_deleted": "تم حذف الوحدة بنجاح",
      "user_created": "تم إنشاء المستخدم بنجاح",
      "user_updated": "تم تحديث المستخدم بنجاح",
      "user_deleted": "تم حذف المستخدم بنجاح",
      "booking_created": "تم إنشاء الحجز بنجاح",
      "booking_updated": "تم تحديث الحجز بنجاح",
      "booking_deleted": "تم حذف الحجز بنجاح",
      
      // Booking conflicts
      "cannot_create_booking_past_date": "لا يمكن إنشاء حجز لتاريخ {{date}} - التاريخ في الماضي. فعّل \"السماح بالحجوزات الماضية\" لإنشاء حجوزات لتواريخ سابقة.",
      "booking_conflict_check_failed": "تحذير: لا يمكن فحص تعارض الحجوزات. يرجى التحقق من التوفر يدوياً.",
      "conflicting_booking_details": "حجز متعارض: #{{id}} - {{tenant}} ({{startDate}} إلى {{endDate}}) على {{unitName}}",
      "conflict_same_unit": "الوحدة '{{unitName}}' محجوزة مسبقاً للتواريخ المحددة.",
      "conflict_parent_unit": "لا يمكن حجز '{{unitName}}' لأن الوحدة الرئيسية '{{conflictingUnitName}}' محجوزة مسبقاً لتواريخ متداخلة.",
      "conflict_child_unit": "لا يمكن حجز '{{unitName}}' لأن الوحدة الفرعية '{{conflictingUnitName}}' محجوزة مسبقاً لتواريخ متداخلة.",
      "conflict_default": "تم اكتشاف تعارض في الحجز للتواريخ المحددة.",
      
      // Dashboard specific
      "welcome_back": "مرحباً بعودتك",
      "whats_happening_today": "إليك ما يحدث مع عقاراتك اليوم.",
      "total_properties": "إجمالي العقارات",
      "total_units": "إجمالي الوحدات",
      "total_bookings": "إجمالي الحجوزات",
      "active_bookings": "الحجوزات النشطة",
      "properties_managed": "العقارات المدارة",
      "available_units": "الوحدات المتاحة",
      "all_time_bookings": "جميع الحجوزات",
      "currently_active": "نشطة حالياً",
      "all_properties": "جميع العقارات",
      "your_properties": "عقاراتك",
      "no_properties_yet": "لا توجد عقارات حتى الآن",
      "start_creating_first_property": "ابدأ بإنشاء عقارك الأول",
      "ask_admin_assign_properties": "اطلب من المدير تعيين عقارات لك",
      "add_your_first_property": "أضف عقارك الأول",
      "create_first_property": "أنشئ عقارك الأول للبدء",
      
      // Properties page specific
      "manage_property_portfolio": "إدارة محفظة العقارات الخاصة بك",
      "view_details": "عرض التفاصيل",
      "facilities_label": "المرافق:",
      "more_facilities": "المزيد",
      "press_enter_to_add": "اضغط Enter لإضافة العناصر",
      "property_type_apartment": "مبنى",
      "property_type_house": "وحدة واحدة",
      "property_type_condo": "شقة ملكية",
      "property_type_townhouse": "تاون هاوس",
      "property_type_commercial": "تجاري",
      "property_type_building": "مبنى",
      "property_type_villa": "فيلا",
      "property_type_other": "أخرى",
      "select_property_to_view_reports": "يرجى اختيار عقار لعرض التقارير المالية",
      "select_property_to_view_income": "يرجى اختيار عقار لعرض بيان الدخل",
      "unit_type_apartment": "شقة",
      "unit_type_room": "غرفة",
      "unit_type_studio": "استوديو",
      "unit_type_suite": "جناح",
      "mobile_phone_1": "رقم الجوال",
      "mobile_phone_2": "رقم الواتساب",
      "special_specifications": "المواصفات الخاصة",
      "select_country": "اختر دولة",
      "saving": "جاري الحفظ...",
      "create": "إنشاء",
      "update": "تحديث",
      "failed_fetch_properties": "فشل في جلب العقارات",
      "failed_save_property": "فشل في حفظ العقار",
      
      // Registration/Login specific
      "create_account": "إنشاء حساب",
      "join_property_management": "انضم إلى نظام إدارة العقارات الخاص بنا",
      "sign_in_to_account": "تسجيل الدخول إلى حساب إدارة العقارات الخاص بك",
      "demo_accounts": "حسابات تجريبية:",
      "admin_demo": "المدير: admin@property.com / password123",
      "user_demo": "المستخدم: john@property.com / password123",
      "email_address": "عنوان البريد الإلكتروني",
      "creating_account": "إنشاء الحساب...",
      "already_have_account": "هل لديك حساب بالفعل؟",
      "sign_in_here": "سجل الدخول هنا",
      "registration_failed": "فشل التسجيل",
      "name_required": "الاسم مطلوب",
      "name_min_length": "يجب أن يكون الاسم حرفين على الأقل",
      "email_required": "البريد الإلكتروني مطلوب",
      "invalid_email_format": "صيغة البريد الإلكتروني غير صالحة",
      "password_required": "كلمة المرور مطلوبة",
      "password_must_match": "يجب أن تتطابق كلمات المرور",
      "confirm_password_required": "تأكيد كلمة المرور مطلوب",
      
      // Profile page
      "my_profile": "ملفي الشخصي",
      "profile_information": "معلومات الملف الشخصي",
      "phone_number": "رقم الهاتف",
      "not_provided": "غير محدد",
      "change_password": "تغيير كلمة المرور",
      "current_password": "كلمة المرور الحالية",
      "new_password": "كلمة المرور الجديدة",
      "confirm_new_password": "تأكيد كلمة المرور الجديدة",
      "current_password_required": "كلمة المرور الحالية مطلوبة",
      "new_password_required": "كلمة المرور الجديدة مطلوبة",
      "passwords_do_not_match": "كلمات المرور غير متطابقة",
      "update_password": "تحديث كلمة المرور",
      "updating": "جاري التحديث...",
      "password_change_description": "قم بتغيير كلمة مرور حسابك للحفاظ على أمان حسابك.",
      "profile_updated_successfully": "تم تحديث الملف الشخصي بنجاح",
      "profile_update_failed": "فشل في تحديث الملف الشخصي",
      "password_updated_successfully": "تم تحديث كلمة المرور بنجاح",
      "password_update_failed": "فشل في تحديث كلمة المرور",
      "user_not_found": "المستخدم غير موجود",
      "account_information": "معلومات الحساب",
      "user_id": "معرف المستخدم",
      "account_status": "حالة الحساب",
      "active": "نشط",
      "inactive": "غير نشط",
      "member_since": "عضو منذ",
      "email_verified": "البريد الإلكتروني محقق",
      "verified": "محقق",
      "not_verified": "غير محقق",
      "preferences": "التفضيلات",
      "assigned_properties": "العقارات المخصصة",
      "you_have_access_to": "لديك حق الوصول إلى",
      "administrator": "مدير",
      "property_manager": "مدير عقارات",
      "staff": "موظف",
      
      // Users page
      "user_management_system": "نظام إدارة المستخدمين",
      "manage_users_permissions": "إدارة المستخدمين وصلاحياتهم",
      "no_users_found": "لم يتم العثور على مستخدمين",
      "add_new_user": "إضافة مستخدم جديد",
      "no_assignments": "لا توجد تعيينات",
      "assign_property": "تعيين عقار",
      "assign_properties_to_cleaner": "تعيين عقارات للمنظف",
      "view_user_details": "عرض تفاصيل المستخدم",
      "delete_user": "حذف المستخدم",
      "create_user": "إنشاء مستخدم",
      "update_user": "تحديث المستخدم",
      
      // Purchase Invoice
      "purchase_invoice": "فاتورة شراء",
      "invoice_information": "معلومات الفاتورة",
      "invoice_number": "رقم الفاتورة",
      "invoice_date": "تاريخ الفاتورة",
      "vendor_name": "اسم المورد",
      "vendor_address": "عنوان المورد",
      "due_date": "تاريخ الاستحقاق",
      "line_items": "بنود الفاتورة",
      "add_item": "إضافة بند",
      "total_amount": "المبلغ الإجمالي",
      "additional_notes_optional": "ملاحظات إضافية (اختيارية)",
      "create_invoice": "إنشاء فاتورة",
      "please_select_expense_category_first": "يرجى اختيار فئة المصاريف للبند الأول قبل إضافة بنود أخرى",
      "active_users": "المستخدمون النشطون",
      "inactive_users": "المستخدمون غير النشطين",
      "all_users": "جميع المستخدمين",
      "role": "الدور",
      "created_at": "تاريخ الإنشاء",
      "last_login": "آخر تسجيل دخول",
      "never": "أبداً",
      
      // Bookings page
      "booking_management": "إدارة الحجوزات",
      "manage_all_bookings": "إدارة جميع الحجوزات والتحفظات",
      "no_bookings_found": "لم يتم العثور على حجوزات",
      "add_new_booking": "إضافة حجز جديد",
      "guest_information": "معلومات الضيف",
      "booking_information": "معلومات الحجز",
      "check_in_date": "تاريخ الوصول",
      "check_out_date": "تاريخ المغادرة",
      "select_property": "اختر العقار",
      "select_unit": "اختر الوحدة",
      "property_required": "العقار مطلوب",
      "unit_required": "الوحدة مطلوبة",
      "guest_name_required": "اسم الضيف مطلوب",
      "checkin_required": "تاريخ الوصول مطلوب",
      "checkout_required": "تاريخ المغادرة مطلوب",
      "creating_booking": "إنشاء الحجز...",
      "updating_booking": "تحديث الحجز...",
      "booking_saved": "تم حفظ الحجز بنجاح",
      "booking_error": "خطأ في حفظ الحجز",
      
      // Map location picker
      "select_location_on_map": "اختر الموقع على الخريطة",
      "search_address": "البحث عن العنوان",
      "use_current_location": "استخدم الموقع الحالي",
      "getting_location": "جاري الحصول على الموقع...",
      "click_map_to_select_location": "انقر على الخريطة لاختيار موقع",
      "selected_coordinates": "الإحداثيات المحددة",
      "confirm_location": "تأكيد الموقع",
      "address_not_found": "العنوان غير موجود",
      "geocoding_error": "خطأ في البحث عن العنوان",
      "location_access_denied": "تم رفض الوصول إلى الموقع",
      "location_access_denied_detailed": "تم رفض الوصول إلى الموقع. الرجاء السماح بالوصول إلى الموقع في إعدادات المتصفح والمحاولة مرة أخرى.",
      "geolocation_not_supported": "تحديد الموقع الجغرافي غير مدعوم من هذا المتصفح",
      "latitude": "خط العرض",
      "longitude": "خط الطول",
      "select_on_map": "اختر على الخريطة",
      "location": "الموقع",
      "location_not_available": "الموقع غير متاح",
      "no_location_set": "لم يتم تعيين موقع لهذا العقار",
      "set_location_instructions": "لتعيين موقع لهذا العقار، انتقل إلى صفحة العقارات وقم بتحرير هذا العقار باستخدام منتقي الخريطة.",
      "go_to_properties": "انتقل إلى العقارات",
      "edit_location": "تحرير الموقع",
      "set_location": "تحديد الموقع",
      "click_set_location_to_add": "انقر على زر 'تحديد الموقع' لإضافة موقع لهذا العقار",
      "please_select_location": "الرجاء اختيار موقع على الخريطة",
      "location_unavailable": "الموقع غير متاح",
      "location_unavailable_detailed": "موقعك غير متاح حاليًا. الرجاء التحقق من إعدادات الموقع على جهازك.",
      "location_timeout": "انتهت مهلة طلب الموقع",
      "location_timeout_detailed": "انتهت مهلة طلب الموقع. الرجاء المحاولة مرة أخرى أو اختيار موقعك على الخريطة.",
      "location_error": "خطأ في الحصول على الموقع",
      "location_error_detailed": "فشل في الحصول على موقعك. الرجاء المحاولة مرة أخرى أو اختيار موقعك على الخريطة.",
      "location_requires_https": "الوصول إلى الموقع يتطلب اتصالاً آمناً (HTTPS). الرجاء استخدام HTTPS أو اختيار موقعك على الخريطة.",
      "location_permission_denied_status": "الوصول إلى الموقع محظور حاليًا. الرجاء تفعيل الوصول إلى الموقع في إعدادات المتصفح.",
      "location_access_help": "كيفية تفعيل الوصول إلى الموقع",
      "location_access_help_intro": "لاستخدام موقعك الحالي، يحتاج المتصفح إلى إذن للوصول إلى موقعك. إليك كيفية تفعيله:",
      "browser_instructions": "تعليمات المتصفح",
      "chrome_location_instructions": "انقر على أيقونة الموقع في شريط العنوان، ثم اختر 'السماح'",
      "firefox_location_instructions": "انقر على أيقونة الدرع في شريط العنوان، ثم فعّل الوصول إلى الموقع",
      "safari_location_instructions": "اذهب إلى Safari > الإعدادات > مواقع الويب > الموقع، ثم اسمح بالوصول",
      "location_access_alternative": "البديل",
      "click_map_to_select_manually": "انقر في أي مكان على الخريطة لاختيار موقعك يدوياً",
      "help": "مساعدة",
      "view_on_google_maps": "عرض على خرائط جوجل",
      "view_on_openstreetmap": "عرض على الخريطة المفتوحة",
      "enter_location_url": "إدخال رابط الموقع",
      "supported_urls_description": "يدعم خرائط جوجل، الخريطة المفتوحة، خرائط أبل، خرائط بينغ، وروابط الإحداثيات",
      "paste_location_url_placeholder": "الصق رابط موقع (مثل من خرائط جوجل، الخريطة المفتوحة، إلخ)",
      "extract_location": "استخراج الموقع",
      "please_enter_location_url": "الرجاء إدخال رابط الموقع",
      "could_not_extract_coordinates": "لا يمكن استخراج الإحداثيات من الرابط. الرجاء التحقق من تنسيق الرابط.",
      "shortened_url_not_supported": "الروابط المختصرة غير مدعومة مباشرة. الرجاء فتح الرابط في متصفحك ونسخ الرابط الكامل من شريط العنوان.",
      "or_enter_location_url": "أو أدخل رابط الموقع",
      "paste_url_from_google_maps_etc": "الصق رابط من خرائط جوجل، الخريطة المفتوحة، أو أي خدمة خرائط",
      "extract": "استخراج",
      "coordinates": "الإحداثيات",
      
      // Accounting
      "accounting": "المحاسبة",
      "accounting_description": "إدارة مالية العقارات وتتبع الإيرادات والمصروفات",
      "chart_of_accounts": "دليل الحسابات",
      "accounting_dashboard": "لوحة تحكم المحاسبة",
      "net_income": "صافي الدخل",
      "cash_balance": "رصيد النقدية",
      "accounts_receivable": "حسابات مدينة",
      "accounts_payable": "حسابات دائنة",
      "journal_entries": "قيود اليومية",
      "general_ledger": "دفتر الأستاذ العام",
      "income_statement": "قائمة الدخل",
      "balance_sheet": "الميزانية العمومية",
      "create_transaction": "إنشاء معاملة",
      "account_code": "رمز الحساب",
      "account_name": "اسم الحساب",
      "account_type": "نوع الحساب",
      "normal_balance": "الرصيد الطبيعي",
      "debit": "مدين",
      "credit": "دائن",
      "transaction_date": "تاريخ المعاملة",
      "transaction_type": "نوع المعاملة",
      "booking_payment": "دفع الحجز",
      "property_expense": "مصروف العقار",
      "adjustment": "تسوية",
      "posted": "مرحل",
      "draft": "مسودة",
      "asset": "أصل",
      "liability": "التزام",
      "equity": "حقوق الملكية",
      "income": "إيراد",
      "cogs": "تكلفة البضاعة المباعة",
      "operating_expense": "مصروف تشغيلي",
      "other_income": "إيرادات أخرى",
      "other_expense": "مصروفات أخرى",
      "current_assets": "أصول متداولة",
      "fixed_assets": "أصول ثابتة",
      "current_liabilities": "التزامات متداولة",
      "long_term_liabilities": "التزامات طويلة الأجل",
      "debit_amount": "مبلغ مدين",
      "credit_amount": "مبلغ دائن",
      "transaction_total": "إجمالي المعاملة",
      "post_transaction": "ترحيل المعاملة",
      "view_transaction": "عرض المعاملة",
      "transaction_details": "تفاصيل المعاملة",
      "account_balance": "رصيد الحساب",
      "running_balance": "الرصيد الجاري",
      
      // Calendar Display Options
      "day_display": "عرض اليوم",
      "calendar_mode": "وضع التقويم",
      "booking": "الحجز",
      "change_rate": "تغيير السعر",
      "none": "لا شيء",
      "day_numbers": "أرقام الأيام",
      "rates": "الأسعار",
      
      // Payment Vouchers
      "payment_vouchers": "قسائم الدفع",
      "payment_voucher": "قسيمة الدفع",
      "create_payment_voucher": "إنشاء قسيمة دفع",
      "voucher_number": "رقم القسيمة",
      "broker_information": "معلومات الوسيط",
      "payment_date": "تاريخ الدفع",
      "payment_method": "طريقة الدفع",
      "remaining_amount": "المبلغ المتبقي",
      "pay_full_amount": "دفع المبلغ الكامل",
      "pay_half_amount": "دفع نصف المبلغ",
      "create_voucher": "إنشاء قسيمة",
      "creating": "جاري الإنشاء...",
      "confirm_approve_voucher": "هل أنت متأكد من الموافقة على هذه القسيمة؟",
      "confirm_pay_voucher": "هل أنت متأكد من دفع هذه القسيمة؟",
      "confirm_cancel_voucher": "هل أنت متأكد من إلغاء هذه القسيمة؟",
      "confirm_delete_voucher": "هل أنت متأكد من حذف هذه القسيمة؟",
      "error_loading_vouchers": "خطأ في تحميل القسائم",
      "no_vouchers_found": "لم يتم العثور على قسائم",
      "select_broker_first": "اختر الوسيط أولاً",
      "no_bookings_with_commission": "لم يتم العثور على حجوزات بها عمولة",
      "optional": "اختياري",
      "no_booking_selected": "لم يتم اختيار حجز"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
